export const typeOfBeansLinks = [
    {
        id: 16,
        text: 'Original Refried Beans',
        slug: 'original-recipe-refried-beans',
    },
    {
        id: 14,
        text: 'Black Refried Beans',
        slug: 'Black-Refried-beans',    
    },
    {                       
        id: 15,
        text: 'Mayocoba Refried Beans',
        slug: 'mayocoba-refried-beans',
    },
    {
        id: 13,
        text: 'Fat Free Refried Beans',
        slug: 'Low-Fat-Refried-Beans',
    },
    {
        id: 12,
        text: 'Traditional Refried Beans',
        slug: 'Traditional-Refried-Beans',
    },
    {
        id: 11,
        text: 'Whole Black Beans',
        slug: 'Whole-Black-Beans',
    },
    {
        id: 10,
        text: 'Whole Mayocoba Beans',
        slug: 'Whole-Mayocoba-Beans',
    },
    {
        id: 9,
        text: 'Whole Pinto Beans',
        slug: 'Whole-Pinto-Beans',
    },
];
